export const SUPABASE_URL = 'https://tgocemvrvlrpkljdcyon.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRnb2NlbXZydmxycGtsamRjeW9uIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk4MjI0MjAsImV4cCI6MjA3NTM5ODQyMH0.BKMvHKzVTj4rowB5u8QWVRItmXjFQARko3ffVL_nkgI';

